<template>
  <div class="birght-dark">
    <el-switch
      style="display: block"
      v-model="birght"
      active-color="#00d0ff"
      inactive-color="#868686"
      active-text="亮色模式"
      inactive-text="深色模式"
      @change="switchChange"
    >
    </el-switch>
  </div>
</template>

<script>
export default {
  data() {
    return {
      birght: true
    };
  },
  methods: {
    switchChange(val) {
      this.$store.commit("app/changeMenuTheme", val);
    }
  },
  created() {
    let meunTheme = this.$store.state.app.menuTheme;
    meunTheme == "birght" ? (this.birght = true) : (this.birght = false);
  }
};
</script>
<style lang="less">
.birght-dark{
  margin-top: 16px;
  margin-right: 10px;
  .el-switch__label.is-active {
    color: #FFFFFF !important;
  }
  .el-switch__label{
    color: #5f5f5f !important;
  }
}
</style>
